// ----------------------------------------------------------------------

export default function Card(theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.customShadows.card,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: theme.shape.borderRadiusSm,
          position: "relative",
          zIndex: 0, // Fix Safari overflow: hidden with border radius
          transition: theme.transitions.create(['border-color', 'box-shadow'], {
            duration: theme.transitions.duration.shorter,
          }),
          '&:hover': {
            borderColor: theme.palette.grey[400],
            boxShadow: `0 4px 12px ${theme.palette.action.hover}`,
          },
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: "subtitle1" },
        subheaderTypographyProps: { variant: "body2" },
      },
      styleOverrides: {
        action: {
          margin: 0,
          alignSelf: "center",
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
        },
      },
    },
  };
}
